import getPriceRangeForPriceTypes from './getPriceRangeForPriceTypes';
import { Screen, ScreenResponse, ScreenZone } from './types';
import type CurrencyFormatter from '../../tnew/currency/CurrencyFormatter';
import type ZonePriceTypeMap from './ZonePriceTypeMap';

function getScreenPriceTypes(zonePriceTypeMap: ZonePriceTypeMap, screenZonesMap: ScreenZone[], screenId: number, defaultPriceTypeId: number) {
  const screenZoneIds = screenZonesMap.filter((o) => o.screenId === screenId)
    .map((o) => o.zoneId);

  const priceTypes = screenZoneIds.map((zoneId) => zonePriceTypeMap.getPriceType(zoneId, defaultPriceTypeId));

  return priceTypes.filter((el) => !!el);
}

export interface ProcessScreensData {
  screens: ScreenResponse[];
  priceRangeIncludesAllPriceTypes: boolean;
  currencyFormatter: CurrencyFormatter;
  globalScreenButtonShouldDisplayPriceTypeDescription: boolean;
  globalScreenButtonShouldRenderPriceRange: boolean;
  defaultPriceTypeId: number | undefined;
  zonePriceTypeMap: ZonePriceTypeMap;
  screenZonesMap: ScreenZone[];
}

function processScreens({
  screens,
  priceRangeIncludesAllPriceTypes,
  currencyFormatter,
  globalScreenButtonShouldDisplayPriceTypeDescription,
  globalScreenButtonShouldRenderPriceRange,
  defaultPriceTypeId,
  zonePriceTypeMap,
  screenZonesMap,
}: ProcessScreensData): Screen[] {
  return screens.map((screen) => {
    let redirectUrl: string | null = screen.RedirectUrl;

    // Clean up RedirectUrl - expecting something like "z={zone_no}"
    if (redirectUrl === 'None') {
      redirectUrl = null;
    }

    let minPriceDisplay = '';
    let maxPriceDisplay = '';

    let screenButtonShouldDisplayPriceTypeDescription = false;
    let screenButtonShouldRenderPriceRange = false;

    if (screen.IsAvailable) {
      let minPrice;
      let maxPrice;

      if (priceRangeIncludesAllPriceTypes) {
        minPrice = parseFloat(screen.MinPrice);
        maxPrice = parseFloat(screen.MaxPrice);
      } else {
        const priceTypes = getScreenPriceTypes(zonePriceTypeMap, screenZonesMap, screen.ScreenId, defaultPriceTypeId);

        const prices = getPriceRangeForPriceTypes(priceTypes);

        // eslint-disable-next-line prefer-destructuring
        minPrice = prices[0];
        maxPrice = prices[prices.length - 1];
      }

      minPriceDisplay = currencyFormatter.format(minPrice);
      maxPriceDisplay = currencyFormatter.format(maxPrice);

      screenButtonShouldDisplayPriceTypeDescription = globalScreenButtonShouldDisplayPriceTypeDescription && !priceRangeIncludesAllPriceTypes;
      screenButtonShouldRenderPriceRange = globalScreenButtonShouldRenderPriceRange;
    }

    return {
      redirectUrl,
      screenButtonShouldDisplayPriceTypeDescription,
      screenButtonShouldRenderPriceRange,
      minPriceDisplay,
      maxPriceDisplay,
      id: screen.ScreenId,
      seatMapId: screen.ScreenMapId,
      isAvailable: screen.IsAvailable,
      isSyos: screen.IsSYOS,
      description: screen.ScreenDescription,
      skipScreenSelection: screen.SkipScreenSelection,
      priceTypeDescription: screen.PriceType,
      facilityAltText: screen.FacilityAltText,
    };
  });
}

export default processScreens;
